/**
* Created by Omar Alejandro Leonor Avalos on 2017-06-06.
*/
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Dialog, TextField } from 'material-ui';
import IconButton from 'material-ui/IconButton';
import Trash from 'material-ui/svg-icons/action/delete';
import Agregar from 'material-ui/svg-icons/content/add-circle';
import FlatButton from 'material-ui/FlatButton';
import { List, ListItem } from 'material-ui/List';
import { blue500, yellow600 } from 'material-ui/styles/colors';
import ActionAssignment from 'material-ui/svg-icons/action/assignment';
import ActionInfo from 'material-ui/svg-icons/action/info';
import Avatar from 'material-ui/Avatar';
import EditorInsertChart from 'material-ui/svg-icons/editor/insert-chart';
import { SubHeader } from '../../../components/layout';
import { EditableInline, EditableInlineV2 } from '../../../components/text';
import AutoComplete from 'material-ui/AutoComplete';
import { parsePath, getValueFromSelectList } from '../../../common/helpers';
import { setValueIn } from '../../../common/immutable';
import { serializeParams } from '../../../common/helpers';
import { buildErrorsState, validateField, errorsEmpty } from '../../../validations';
import { isEmpty } from 'lodash';
import { preInvoice as preInvoiceService } from '../../../services';

const errorsProps = {
    customer: [],
    originDestination: [],
    shippingCompany: [],
    arrivalTimestamp: [],
    requestingNumber: [],
    type: [],
    via: [],
    packages: [],
    weight: [],
    customsValue: []
};

//Each rule might correspond with the key for the field to validate
//For now I only use
var rules = {};

var DeletedAttachedFiles = [];

class Info extends Component {

    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            errors: { ...errorsProps },
            DisableSave: true
        }
    }

    updateCustomsClearence(path, value) {
        //Recalculate errors
        const errors = Object.assign(
            {},
            this.state.errors,
            validateField(rules, path, value)
        );
        this.props.notify({ op: 'update', path: `modalInfoState>customsClearence>${path}`, value: value });
        this.setState({ errors });

    }

    updateAttachedFile(path, value) {
        //Recalculate errors
        const errors = Object.assign(
            {},
            this.state.errors,
            validateField(rules, path, value)
        );

        this.props.notify({ op: 'update', path: path, value: value });

        this.setState({ errors });

    }

    removeElement(ArrayFiles, ValuetoRemove, index) {

        ArrayFiles.splice(index, 1);

        this.updateAttachedFile('attachedFiles', ArrayFiles)

        DeletedAttachedFiles.push(ValuetoRemove);

    }

    renderFacturas(customClearenceInfo) {
        var NameArray = [{ "name": "number0" }];

        if (customClearenceInfo.id != null || customClearenceInfo.id != undefined) {
            NameArray = this.props.preInvoices;
        }

        if (NameArray != undefined) {
            return (
                <ListItem
                    primaryText="Ver todas las prefacturas"
                    leftIcon={<ActionAssignment />}
                    initiallyOpen={false}
                    primaryTogglesNestedList={true}
                    nestedItems={
                        NameArray.map((obj, index) =>
                            <ListItem
                                leftAvatar={<Avatar icon={<ActionAssignment />} backgroundColor={blue500} />}
                                primaryText={customClearenceInfo.folio + "_" + obj.folioSequence}
                                onClick={() => {
                                    preInvoiceService.downloadFile({
                                        customsClearenceFolio: customClearenceInfo.folio,
                                        preInvoiceSequence: obj.folioSequence
                                    })
                                }}
                                key={index}
                            />
                        )
                    }
                />
            );
        }
    }

    renderAttachedFiles(customClearenceInfo) {
        var NameArray = [{ "name": "number0" }];

        if (customClearenceInfo.id != null || customClearenceInfo.id != undefined) {
            NameArray = this.props.attachedFiles;
        }

        if (NameArray != undefined) {
            return (
                <ListItem
                    primaryText="Ver todos los archivos adjuntos"
                    leftIcon={<ActionAssignment
                    />}
                    initiallyOpen={false}
                    primaryTogglesNestedList={true}
                    nestedItems={
                        NameArray.map((obj, index) =>
                            <ListItem
                                leftAvatar={<Avatar icon={<EditorInsertChart />} backgroundColor={yellow600} />}
                                rightIcon={
                                    this.state.editing ?
                                        <Trash
                                            onClick={() => {
                                                this.removeElement(NameArray, obj.toString(), index);
                                            }}
                                        /> : null
                                }
                                primaryText={obj.toString()}
                                onClick={() => {
                                    preInvoiceService.downloadAttachedFile({
                                        customsClearenceFolio: customClearenceInfo.folio,
                                        fileName: obj.toString()
                                      });
                                }}
                                key={index}
                            />
                        )
                    }
                />
            );
        }
    }

    render() {
        const { editing, DisableSave, errors } = this.state;
        const { modalInfoState, notify, customsHouses, AuxActions, preinvoices, allowAttachments, allowUpdate, allowOnlyToModifyRequestPayment, allowReadPreinvoice, attachedFiles } = this.props;

        const selectedCustomsHouse = this.props.customsHouses.items.find(ch => ch.uuid === this.props.modalInfoState.customsClearence.customsHouse.id);
        const requireRequestingNumber = selectedCustomsHouse && selectedCustomsHouse.ownOffice;
        const requestingNumberBasicRule = { key: 'validationMask', errorText: 'Por favor debe ser tipo XXXX-YYYYYYY' };
        const requestingNumberRules = requireRequestingNumber ?
            [requestingNumberBasicRule, { key: 'required', errorText: 'Campo Requerido' }] : [requestingNumberBasicRule];

        const rulesAux = {
            customer: [{ key: 'required', errorText: 'Por favor, seleccione el cliente' }],
            supplier: [{ key: 'required', errorText: 'Por favor, seleccione al proveedor' }],
            arrivalTimestamp: [{ key: 'required', errorText: 'Por favor, seleccione la fecha de arribo' }],
            requestingNumber: requestingNumberRules,
            type: [{ key: 'required', errorText: 'Campo requerido' }],
            originDestination: [{ key: 'required', errorText: 'Campo requerido' }],
            customsHouse: [{ key: 'required', errorText: 'Campo requerido' }],
            shippingCompany: [{ key: 'required', errorText: 'Campo requerido' }],
            via: [{ key: 'required', errorText: 'Campo requerido' }],
            packages: [
                { key: 'required', errorText: 'Campo requerido' },
                { key: 'packagesRules', errorText: 'Indique el numero seguido de Concepto' }
            ],
            weight: [
                { key: 'required', errorText: 'Campo requerido' },
                { key: 'numberWithDecimals', errorText: 'Numero invalido' }
            ],
            customsValue: [{ key: 'onlyMonetaryValues', errorText: 'Por favor, ingrese valores monetarios' }]
        };

        rules = rulesAux;

        const actions = [
            <FlatButton
                label="Cancelar"
                primary
                onTouchTap={() => {
                    notify({ op: 'update', path: 'modalInfoState', value: { modalInfoOpen: false, customsClearence: { ...modalInfoState.customsClearence }, index: '' } });
                    this.setState({ editing: false, DisableSave: true });
                }}
            />,
            (allowUpdate || allowOnlyToModifyRequestPayment) &&
            < FlatButton
                label="Editar"
                primary
                onTouchTap={() =>
                    this.setState({ editing: true, DisableSave: false })
                }
            />,
            (allowUpdate || allowOnlyToModifyRequestPayment) &&
            < FlatButton
                label="Guardar"
                primary
                disabled={DisableSave}
                onTouchTap={() => {
                    if (errorsEmpty(this.state.errors)) {
                        notify({ op: 'update', path: 'modalInfoState', value: { modalInfoOpen: false, customsClearence: { ...modalInfoState.customsClearence }, index: '' } })
                        this.setState({ editing: false, DisableSave: true });
                        this.props.AuxActions.onSave();
                        this.props.AuxActions.DeletedAttachedFiles(DeletedAttachedFiles, modalInfoState.customsClearence.folio);
                    }
                }}
            />
        ];
        return (
            <div>
                <Dialog
                    title="Información del Despacho"
                    className="modalstyle"
                    open={modalInfoState.modalInfoOpen}
                    modalInfoOpen
                    actions={actions}
                    autoScrollBodyContent
                >
                    <div className="row">
                        <div className="col-md-12 pl0 pr0 margin-top-2">
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <p className="text-bold text-color-light">Cliente Asignado</p>
                                <EditableInlineV2
                                    type="remoteAutocomplete"
                                    editViewActive={editing && allowUpdate}
                                    value={modalInfoState.customsClearence.customer.name}
                                    serviceName='customers'
                                    entity='customers'
                                    url='/customers/search/findTop10ByNameIgnoreCaseContaining'
                                    onAdd={() => notify({ op: 'update', path: 'formOpenNewCustomer', value: true })}
                                    projectionName='forListing'
                                    notify={(value) => {
                                        this.updateCustomsClearence('customer', value);
                                    }}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <p className="text-bold text-color-light">Proveedor Asignado</p>
                                <EditableInlineV2
                                    type="remoteAutocomplete"
                                    editViewActive={editing && allowUpdate}
                                    value={modalInfoState.customsClearence.supplier.name}
                                    serviceName='suppliers'
                                    entity='suppliers'
                                    url='/suppliers/search/findTop10ByNameIgnoreCaseContaining'
                                    onAdd={() => notify({ op: 'update', path: 'formOpenNewSupplier', value: true })}
                                    projectionName='forListing'
                                    notify={(value) => this.updateCustomsClearence('supplier', value)}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <p className="text-bold text-color-light">Aduana de Despacho</p>
                                {
                                    modalInfoState.customsClearence.customsHouse.name != undefined &&
                                    <EditableInlineV2
                                        type="autocomplete"
                                        editViewActive={editing && allowUpdate}
                                        value={getValueFromSelectList(customsHouses.items, modalInfoState.customsClearence.customsHouse.name).name}
                                        items={customsHouses.items}
                                        notify={(value) => {
                                            this.updateCustomsClearence('customsHouse>name', value.id);
                                            this.updateCustomsClearence('customsHouse>id', value.uuid)
                                        }}
                                    />
                                }
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <EditableInlineV2
                                    type="autocomplete"
                                    value={getValueFromSelectList([
                                        { id: 'EXPORT', name: 'Exportacion' },
                                        { id: 'IMPORT', name: 'Importacion' }
                                    ], modalInfoState.customsClearence.type).name}
                                    label="Tipo"
                                    items={[
                                        { id: 'EXPORT', name: 'Exportacion' },
                                        { id: 'IMPORT', name: 'Importacion' }
                                    ]}
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => this.updateCustomsClearence('type', value.id)
                                    }
                                    errorText={errors.type.join(' | ')}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <EditableInlineV2
                                    type="date"
                                    label={modalInfoState.customsClearence.type === "EXPORT" ? "Fecha salida" : "Fecha arribo"}
                                    value={modalInfoState.customsClearence.arrivalTimestamp}
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => this.updateCustomsClearence('arrivalTimestamp', value)}
                                    errorText={errors.arrivalTimestamp.join(' | ')}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <EditableInlineV2
                                    type="date"
                                    label="Pago del pedimento"
                                    value={modalInfoState.customsClearence.requestingPaymentTimestamp}
                                    editViewActive={editing && (allowUpdate || allowOnlyToModifyRequestPayment)}
                                    notify={(value) => this.updateCustomsClearence('requestingPaymentTimestamp', value)}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <EditableInlineV2
                                    type="text"
                                    value={modalInfoState.customsClearence.originDestination}
                                    label="Origen"
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => this.updateCustomsClearence('originDestination', value)}
                                    errorText={errors.originDestination.join(' | ')}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <EditableInlineV2
                                    type="text"
                                    value={modalInfoState.customsClearence.mawbMbl}
                                    label="MAWB/MBL"
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => {
                                        this.updateCustomsClearence('mawbMbl', value);
                                    }}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <EditableInlineV2
                                    type="text"
                                    value={modalInfoState.customsClearence.hawbHbl}
                                    label="HAWB/HBL"
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => this.updateCustomsClearence('hawbHbl', value)}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <EditableInlineV2
                                    type="text"
                                    value={modalInfoState.customsClearence.customsValue}
                                    label="Valor Aduanal"
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => this.updateCustomsClearence('customsValue', value)}
                                    errorText={errors.customsValue.join(' | ')}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <EditableInlineV2
                                    type="text"
                                    value={modalInfoState.customsClearence.requestingNumber}
                                    label="Número de pedimento"
                                    editViewActive={editing && allowUpdate && !modalInfoState.customsClearence.customsHouse.ownOffice}
                                    notify={(value) => this.updateCustomsClearence('requestingNumber', value)}
                                    errorText={errors.requestingNumber.join(' | ')}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <EditableInlineV2
                                    type="autocomplete"
                                    value={getValueFromSelectList([
                                        { id: 'Terrestre', name: 'Terrestre' },
                                        { id: 'Maritima', name: 'Maritima' },
                                        { id: 'Aerea', name: 'Aerea' }
                                    ], modalInfoState.customsClearence.via).name}
                                    label="Vía"
                                    editViewActive={editing && allowUpdate}
                                    items={[
                                        { id: 'Terrestre', name: 'Terrestre' },
                                        { id: 'Maritima', name: 'Maritima' },
                                        { id: 'Aerea', name: 'Aerea' }
                                    ]}
                                    notify={(value) => this.updateCustomsClearence('via', value.id)}
                                    errorText={errors.via.join(' | ')}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <EditableInlineV2
                                    type="text"
                                    value={modalInfoState.customsClearence.comertialInvoiceNumber}
                                    label="Número de Factura Comercial"
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => this.updateCustomsClearence('comertialInvoiceNumber', value)}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <EditableInlineV2
                                    type="text"
                                    value={modalInfoState.customsClearence.shippingCompany}
                                    label="Aerolínea / Naviera / Carrier"
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => this.updateCustomsClearence('shippingCompany', value)}
                                    errorText={errors.shippingCompany.join(' | ')}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <EditableInlineV2
                                    type="text"
                                    value={modalInfoState.customsClearence.packages}
                                    label="Bultos"
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => {
                                        this.updateCustomsClearence('packages', value);
                                    }}
                                    errorText={errors.packages.join(' | ')}
                                />
                            </div>
                            <div className="col-lg-4 col-sm-6 col-xs-12">
                                <EditableInlineV2
                                    type="text"
                                    value={modalInfoState.customsClearence.weight}
                                    label="Peso"
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => this.updateCustomsClearence('weight', value)}
                                    errorText={errors.weight.join(' | ')}
                                />
                            </div>
                            <div className="col-lg-12 col-xs-12">
                                <EditableInlineV2
                                    type="text"
                                    value={modalInfoState.customsClearence.merchandiseDescription}
                                    label="Descripción de la Mercancía"
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => this.updateCustomsClearence('merchandiseDescription', value)}
                                />
                            </div>
                            <div className="col-lg-12 col-xs-12">
                                <EditableInlineV2
                                    type="text"
                                    value={modalInfoState.customsClearence.comments}
                                    label="Comentarios"
                                    editViewActive={editing && allowUpdate}
                                    notify={(value) => this.updateCustomsClearence('comments', value)}
                                />
                            </div>
                        </div>
                    </div>
                    {
                        (allowAttachments || allowReadPreinvoice) &&
                        <div className="row">
                            <div className="col-md-12 margin-top-2">
                                <h4>Archivos adjuntados al Despacho</h4>
                                <List>
                                    {
                                        allowReadPreinvoice &&
                                        this.renderFacturas(modalInfoState.customsClearence)
                                    }
                                    {
                                        allowAttachments &&
                                        this.renderAttachedFiles(modalInfoState.customsClearence)
                                    }
                                </List>
                            </div>
                        </div>
                    }
                </Dialog>
            </div>
        );
    }
}

export default Info;



// WEBPACK FOOTER //
// ./containers/despachos/components/info.js